import { Stack, Typography } from '@mui/material';
import TextFieldLabel from '@shared/components/inputs/TextFieldLabel/TextFieldLabel';
import RadioGroupSet from '@shared/components/inputs/Radio/RadioGroupSet';
import { FormikTextField } from '@shared/components/inputs/FormikTextField';
import { PhoneNumberField } from '@components/LeadCaptureForm/sections/PhoneNumberField';
import type { LeadCaptureSectionProps } from '@components/LeadCaptureForm/LeadCaptureForm.types';

export const ContactInformationSection = ({ formik }: LeadCaptureSectionProps) => {
  const { values, handleChange } = formik;
  const isResidential = values.customerType === 'RESIDENTIAL';
  const heading = isResidential ? 'Contact Information' : 'Primary Business Contact';
  const emailLabel = isResidential ? 'Email' : 'Business Email';

  return (
    <>
      <Typography variant="label.field" className="lead-capture-section-heading">
        {heading}
      </Typography>
      <Stack direction="row" gap="30px" alignItems="flex-start">
        <FormikTextField
          formik={formik}
          name="firstName"
          label="First Name"
          labelVariant="label.fieldMedium"
          placeholder="Enter your first name..."
          className="lead-capture-text-input"
          containerSx={{ width: '50%' }}
        />
        <FormikTextField
          formik={formik}
          name="lastName"
          label="Last Name"
          labelVariant="label.fieldMedium"
          placeholder="Enter your last name..."
          className="lead-capture-text-input"
          containerSx={{ width: '50%' }}
        />
      </Stack>
      <PhoneNumberField formik={formik} />
      <FormikTextField
        formik={formik}
        name="email"
        label={emailLabel}
        labelVariant="label.fieldMedium"
        placeholder="Enter your email..."
        className="lead-capture-text-input"
      />
      <Stack gap="9px">
        <TextFieldLabel label="Preferred Contact Method" />
        <RadioGroupSet
          row
          name="preferredContactMethod"
          value={values.preferredContactMethod}
          onChange={handleChange}
          options={[
            { value: 'email', label: 'Email' },
            { value: 'phone', label: 'Phone' },
          ]}
        />
      </Stack>
      <FormikTextField
        formik={formik}
        name="bestTimeToContact"
        label="When Is the Best Time to Reach You?"
        labelVariant="label.fieldMedium"
        placeholder="e.g Weekdays 9AM-5PM"
        className="lead-capture-text-input"
      />
    </>
  );
};
